import { Box, FlexBox, Text } from '@trmediaab/zebra';

const decorationStyles = {
  width: '9px',
  height: '28px',
};

const InfoBadge = ({
  isFirst = false,
  bg = 'background.secondary',
  color = 'brands.travrondenSpel',
  children,
}) => (
  <FlexBox sx={{ position: 'relative', width: 'fit-content' }} flexShrink={0}>
    <Box
      bg={bg}
      sx={{
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
        marginRight: '-3px',
        transform: !isFirst ? 'skew(-12deg, 0deg)' : undefined,
        ...decorationStyles,
      }}
    />

    <FlexBox
      alignItems="center"
      height="28px"
      py="1"
      px="3px"
      backgroundColor={bg}
    >
      <Text color={color} fontWeight="bold" fontSize="1">
        {children}
      </Text>
    </FlexBox>

    <Box
      bg={bg}
      sx={{
        borderTopRightRadius: '4px',
        borderBottomRightRadius: '4px',
        marginLeft: '-3px',
        transform: 'skew(-12deg, 0deg)',
        ...decorationStyles,
      }}
    />
  </FlexBox>
);

export default InfoBadge;
